module.exports = "textarea{\r\n    min-height:200px;\r\n}\r\n.content{\r\n\tbackground: white;\r\n\tpadding-top:20px;\r\n\tbackground-color: white;\r\n\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/profile-page/edit-profile/edit-profile.component.css
// module id = ./src/app/pages/profile-page/edit-profile/edit-profile.component.css
// module chunks = main